<template>
  <form @submit.prevent="store_sale_invoice">
    <div class="tw-bg-white tw-border tw-border-[#E2E2E2] tw-py-8 tw-px-4 md:tw-p-8 tw-rounded-[12px]">
      <h3 class="tw-mb-5 tw-text-base tw-text-static-headerGray">اطلاعات پایه</h3>

      <div class="tw-block md:tw-grid md:tw-grid-cols-10 tw-gap-3 tw-mb-8">
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-date-picker title="تاریخ فاکتور"
                            :range="true"
                            v-model="invoice_date"
                            class="tw-mb-6" />
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-date-picker title="تاریخ فاکتور"
                            :range="true"
                            v-model="date_loaded"
                            class="tw-mb-6" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <plate default_letter=""
                 size="sm"
                 v-model:plate="plate"
                 class="tw-mb-6" />
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <select-users title="مشتری"
                        placeholder="انتخاب مشتری"
                        icon="person"
                        v-model="user_id" />
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-select title="محصول"
                       placeholder="انتخاب محصول"
                       :float-title="true"
                       :loading="getDataLoading"
                       v-model="product_id"
                       :options="dataStoreOrder?.products"
                       icon="category"/>
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <input-ayandeh
            v-model:value="number_bar"
            placeholder="شماره بارنامه"
            icon-on-input="barcode"
            float-label="شماره را وارد کنید (اختیاری)" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <base-select title="واحد ارزی"
                       :float-title="true"
                       :loading="false"
                       v-model="price_unit"
                       :options="priceUnits"
                       icon="currency-exchange" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <input-ayandeh
            v-model:value="price_arz"
            placeholder="به ریال"
            :number-format="true"
            icon-on-input="swap-vertical-circle"
            float-label="نرخ ارز" />
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <input-ayandeh
            v-model:value="price_per_ton_arz"
            :placeholder="!!price_unit ?  'به ' + priceUnits.find(x => x.value === price_unit).label : 'فی هر تن'"
            :number-format="true"
            icon-on-input="universal-currency"
            float-label="فی هر تن" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <input-ayandeh
            v-model:value="tonage"
            placeholder="تن"
            icon-on-input="weight"
            float-label="میزان (تن)" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <base-select title="انبار مبدا"
                       placeholder="انبار مبدا را انتخاب کنید"
                       :float-title="true"
                       :loading="getDataLoading"
                       v-model="origin_warehouse_id"
                       :options="dataStoreOrder?.warehouses"
                       icon="warehouse"/>
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <input-ayandeh
            v-model:value="rent"
            :number-format="true"
            placeholder="کرایه هر تن بار"
            icon-on-input="money-bag"
            float-label="کرایه (ریال)" />
        </div>

        <div class="tw-w-full md:tw-col-span-6 tw-mb-6">
          <input-ayandeh
            v-model:value="address"
            :number-format="true"
            placeholder="وارد کردن آدرس (اختیاری)"
            icon-on-input="distance"
            float-label="آدرس" />
        </div>


        <div class="tw-w-full md:tw-col-span-10 tw-mb-6">
          <label>
            <base-icon icon="description" class="tw-align-middle tw-ml-3"/>
            توضیحات
          </label>
          <textarea cols="3"
                    v-model="description"
                    placeholder="نوشتن توضیحات (اختیاری)"
                    :class="[
                  errors['other_sanads['+index+'].description'] ? 'tw-border-red-200' : 'tw-border-static-inputBorder'
                ]"
                    class="tw-border tw-w-full tw-rounded-[8px] tw-p-1.5 tw-min-h-[70px] placeholder:tw-text-gray-700"></textarea>
          <p v-if="errors['other_sanads['+index+'].description']"
             class="tw-text-red-300 tw-mb-0 tw-text-tiny"
             v-text="errors['other_sanads['+index+'].description']"></p>
        </div>

      </div>


    </div>

    <new-manage-other-snd ref="other_sanads_manage"
                          v-model="other_sanads"
                          v-model:validated="other_sanads_validated" />

    <div class="tw-fixed tw-text-primary-500 tw-bottom-0 tw-left-0 tw-w-full tw-px-4 tw-pt-6 tw-pb-5 tw-bg-white tw-flex tw-justify-between tw-border-t tw-border-static-inputBorder2 md:tw-pr-sidebar-width">
      <button type="button" class="tw-bg-white !tw-font-bold !tw-text-primary-500" @click="addOtherSnd">
        <base-icon icon="add-circle" class="tw-ml-3 tw-align-middle" />
        افزودن سند حسابداری
      </button>

      <new-btn class="tw-relative tw-px-5"
               type="submit"
               :loading="loading_store_order"
               :disabled="!other_sanads_validated || loading_store_order"
               variant="fill"
               color="primary">
        ثبت حواله انبار
      </new-btn>
    </div>
  </form>
</template>

<script setup>

import {useStore} from 'vuex'
import {onMounted, ref, nextTick, getCurrentInstance, computed, watch} from "vue";
import BaseSelect from "@/components/base/select/BaseSelect.vue";
import { priceUnits } from '@/services/more/ConstVar'
import InputAyandeh from "@/components/inputs/InputAyandeh.vue";
import { apiGetDataStoreOrder, apiStoreNewOrder }  from '@/services/orders/Orders'
import { apiGetSiteUsers }  from '@/services/users/Users'
import { apiGetCitiesDischarge }  from '@/services/city/Cities'
import BaseIcon from "@/components/base/BaseIcon.vue";
import NewBtn from "@/components/base/btn/NewBtn.vue";
import CardManageOtherSnd from "@/views/sanads_other/CardManageOtherSnd.vue";
import SelectUsers from "@/components/base/select/SelectUsers.vue";
import NewManageOtherSnd from "@/views/sanads_other/NewManageOtherSnd.vue";
import {useForm, useField} from "vee-validate";
import * as yup from 'yup'
import { useRouter } from "vue-router";
import BaseDatePicker from "@/components/base/select/BaseDatePicker.vue";
import Plate from "@/components/partial/Plate.vue";


const invoice_date = ref(null);
const date_loaded = ref(null);
const plate = ref({})
const user_id = ref(null)
const product_id = ref(null)
const description = ref('')
const number_bar = ref('')
const price_unit = ref(null);
const price_arz = ref(null);
const price_per_ton_arz = ref(null);
const address = ref('');

const tonage = ref(null);

const origin_warehouse_id = ref(null);
const rent = ref(null);
const reward = ref(null);
const rent_by = ref(null);
const rent_by_options = [
  { value: 'user', label: 'مشتری'},
  { value: 'ayandeh', label: 'شرکت آینده'},
]
const clearance_by = ref(null);
const clearance_by_options = [
  { value: 'user', label: 'مشتری'},
  { value: 'ayandeh', label: 'شرکت آینده'},
]
const validate_other_sanads = ref(false)
const other_sanads = ref([])
const other_sanads_manage = ref(null)


const cities = ref([])
const pageCities = ref(1)
const hasNextPageCities = ref(false)
const loadingGetCities = ref(false)
const other_sanads_validated = ref(true)
const loading_store_order = ref(false)

const { proxy } = getCurrentInstance()
const router = useRouter()
const store = useStore()

onMounted(() => {
  getCities()
})


const props = defineProps({
  getDataLoading: {
    type: Boolean,
    default: false
  },
  dataStoreOrder: {
    type: Object,
    default: () => {}
  }
})

async function getCities(search = '') {
  loadingGetCities.value = true
  try {
    const response = await apiGetCitiesDischarge({
      search: search,
      page: pageCities.value
    })

    if(!response) return
    if(pageCities.value === 1) {
      cities.value = response?.data?.cities?.data
    } else {
      cities.value = [...cities.value, ...response?.data?.cities?.data]
    }
    hasNextPageCities.value = pageCities.value < response?.data?.cities?.last_page

  } catch (error) {
    console.log(error)
  } finally {
    loadingGetCities.value = false
  }
}



function loadMoreCities(arg) {
  if(arg?.page) {
    pageCities.value = arg.page
  } else {
    pageCities.value++
  }

  if(pageCities.value === 1) {
    cities.value = []
  }
  getCities(arg?.search || '')
}


async  function addOtherSnd() {
  await nextTick()
  other_sanads_manage.value.add_sanad()
}

const { handleSubmit, errors } = useForm({
  validationSchema: {
    invoice_date: yup.array().required('تاریخ فاکتور الزامی است'),
    date_loaded: yup.array().required('تاریخ بارگیری الزامی است'),
    user_id: yup.string().required('فیلد مشتری الزامی است'),
    price_unit: yup.string().required('واحد ارز الزامی است'),
    price_arz: yup.string().required('نرخ ارز الزامی است'),
    price_per_ton_arz: yup.string().required('فی هر تن الزامی است'),
    product_id: yup.string().required('محصول الزامی است'),
    origin_warehouse_id: yup.string().required('انبار مبدا الزامی است'),
    tonage: yup.string().required('میزان خرید الزامی است'),
    rent: yup.string().required('کرایه الزامی است'),
    reward: yup.string().nullable(),
    rent_by: yup.string().required('انتخاب پرداخت کننده کرایه الزامی است'),
    clearance_by: yup.string().required('انتخاب ترخیص کار الزامی است'),
  },
})


async function store_sale_invoice() {
  loading_store_order.value = true
  var data = {
    order_type: 'warehouse_transfer',
    tonage: tonage.value,
    product_id: product_id.value,
    address: address.value,
    description: description.value,
    origin_warehouse_id: origin_warehouse_id.value,
    rent: rent.value,
    reward: reward.value,
    rent_by: rent_by.value,
    clearance_by: clearance_by.value,
    price_unit: price_unit.value,
    price_arz: price_arz.value,
    price_per_ton_arz: price_per_ton_arz.value,
    other_sanads: other_sanads.value.map(function(item) {
      const newItem = { ...item }
      newItem.bank_information_id = item.bank_information?.id
      delete newItem.bank_information

      return newItem
    }),
  }

  try {
    const response = await apiStoreNewOrder(data)
    if(!response) return

    if (response?.data.status === 'success') {
      router.replace('/admin/card/list')
    }
    proxy.$my_alert(response.data.message, response.data.status)

  } catch (error) {
    console.log(error)
  } finally {
    loading_store_order.value = false
  }

}


</script>


<style scoped>

</style>
